<template>
  <section class="integrated-services" id="services">
    <div class="container">
      <div class="section-title text-center">
        <span class="subtitle">Unsere Leistungen</span>
        <h2>Ganzheitliche <span class="text-gradient">Lösungen</span> für Ihr Unternehmen</h2>
        <p class="lead">Wir verbinden KI-Integration und DevOps-Transformation für maximalen Geschäftserfolg</p>
      </div>

      <div class="services-grid">
        <!-- KI-Bereich -->
        <div class="service-area">
          <div class="service-header">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                <path fill="#1DAAE4" d="M320 0c17.7 0 32 14.3 32 32V96H480c17.7 0 32 14.3 32 32v64H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H512v80c0 17.7-14.3 32-32 32H352V384H288v96H160c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H128V128c0-17.7 14.3-32 32-32H288V32c0-17.7 14.3-32 32-32zM176 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H320zM464 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H464z"/>
              </svg>
            </div>
            <h3>KI-Integration</h3>
          </div>
          <div class="service-items">
            <div class="service-item">
              <h4>Datenanalyse & ML-Modelle</h4>
              <p>Wir entwickeln maßgeschneiderte Machine-Learning-Modelle, die Ihre Geschäftsdaten in wertvolle Erkenntnisse umwandeln.</p>
              <ul class="feature-list">
                <li>Predictive Analytics für Geschäftsprozesse</li>
                <li>Computer Vision für Qualitätskontrolle</li>
                <li>Natural Language Processing für Kundenkommunikation</li>
              </ul>
            </div>
            <div class="service-item">
              <h4>KI-gestützte Automatisierung</h4>
              <p>Automatisieren Sie komplexe Prozesse durch intelligente KI-Entscheidungen und reduzieren Sie manuelle Eingriffe.</p>
              <ul class="feature-list">
                <li>Workflow-Optimierung durch intelligente Agenten</li>
                <li>Chatbots und virtuelle Assistenten</li>
                <li>Automatisierte Dokument- und Datenverarbeitung</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- DevOps-Bereich -->
        <div class="service-area">
          <div class="service-header">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 640 512">
                <path fill="#1DAAE4" d="M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"/>
              </svg>
            </div>
            <h3>DevOps-Transformation</h3>
          </div>
          <div class="service-items">
            <div class="service-item">
              <h4>CI/CD-Pipelines & Automatisierung</h4>
              <p>Beschleunigen Sie Ihre Software-Entwicklung durch automatisierte Pipelines und kontinuierliche Integration.</p>
              <ul class="feature-list">
                <li>Aufbau moderner CI/CD-Workflows</li>
                <li>Test-Automatisierung & Quality Gates</li>
                <li>Feedback-Loops & schnelle Fehleridentifikation</li>
              </ul>
            </div>
            <div class="service-item">
              <h4>Cloud-Native Infrastruktur</h4>
              <p>Migrieren Sie zu einer skalierbaren, selbstheilenden Infrastruktur mit containerisierten Anwendungen.</p>
              <ul class="feature-list">
                <li>Kubernetes-Orchestrierung</li>
                <li>Infrastructure as Code (Terraform, Ansible)</li>
                <li>Microservices-Architekturen</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Kombinierter KI/DevOps-Bereich -->
        <div class="service-area">
          <div class="service-header">
            <div class="feature-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                <path fill="#1DAAE4" d="M64 64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM224 160c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 256c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM288 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zM80 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm112 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/>
              </svg>
            </div>
            <h3>KI-gestützte DevOps-Optimierung</h3>
          </div>
          <div class="service-items">
            <div class="service-item">
              <h4>AIOps & Intelligentes Monitoring</h4>
              <p>Nutzen Sie KI zur Vorhersage von Systemausfällen und automatischen Lösung von Infrastrukturproblemen.</p>
              <ul class="feature-list">
                <li>Vorhersagebasierte Skalierung von Ressourcen</li>
                <li>Anomalieerkennung für Systemzustände</li>
                <li>Automatisierte Selbstheilung von Systemen</li>
              </ul>
            </div>
            <div class="service-item">
              <h4>DevSecOps mit KI-Unterstützung</h4>
              <p>Integrieren Sie Sicherheit in jeden Schritt Ihrer DevOps-Prozesse, unterstützt durch KI-basierte Bedrohungsanalyse.</p>
              <ul class="feature-list">
                <li>Automatisierte Sicherheitsprüfungen im Code</li>
                <li>KI-gestützte Erkennung von Sicherheitslücken</li>
                <li>Kontinuierliche Compliance-Überwachung</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'IntegratedServices'
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.integrated-services {
  padding: 100px 0;
  background: linear-gradient(180deg, $background-color, darken($background-color, 3%));
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 50px;
  margin-top: 60px;
}

.service-area {
  background: rgba($secondary-color, 0.4);
  border-radius: 20px;
  padding: 40px;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba($accent-color, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    border-color: rgba($accent-color, 0.3);
  }
  
  .service-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    
    h3 {
      font-size: 1.8rem;
      color: $accent-color;
      margin-left: 20px;
    }
  }
  
  .service-items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
  }
  
  .service-item {
    background: rgba($primary-color, 0.3);
    border-radius: 15px;
    padding: 25px;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba($primary-color, 0.5);
    }
    
    h4 {
      font-size: 1.3rem;
      color: $heading-color;
      margin-bottom: 15px;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 40px;
        height: 3px;
        background: $accent-gradient;
        border-radius: 3px;
      }
    }
    
    p {
      color: $muted-text-color;
      margin-bottom: 20px;
    }
  }
}

.feature-list {
  list-style: none;
  padding-left: 0;
  
  li {
    padding: 8px 0;
    position: relative;
    padding-left: 25px;
    color: $text-color;
    
    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: $accent-color;
    }
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .service-items {
    grid-template-columns: 1fr !important;
  }
}
</style>